<template>
    <div class="hosted-show-information">
        <h2>Enter Your New Show Details</h2>

        <p class="small">
            We only need the title of your podcast to get started. You can change this anytime in the Settings page.
        </p>

        <base-show-information-form
            @submit="show => $emit('proceed', { ...data, show })"
        />
    </div>
</template>
<script>
import BaseShowInformationForm from '@/components/Shows/BaseShowInformationForm';

export default {
    components: {
        BaseShowInformationForm,
    },

    props: {
        data: {
            type: [Object],
            default: () => ({}),
        },
    },
};
</script>
